export enum PaymentModuleId {
  WorldpayCard = 4,
  BraintreePayPal = 6,
  BraintreeCard = 7,
  Transbank = 8,
  PaymentAtSubsidiary = 9,
  Sepa = 10,
  WorldpayIdeal = 11,
  WorldpayBancontact = 12,
  BraintreeApplePay = 13,
  BraintreeGooglePay = 14,
  DirectDebitLSV = 15,
  ECommerceConnect = 17,
  NuveiTwint = 18,
  FlutterwaveCreditCard = 19,
  NuveiCreditCard = 20,
  BraintreeSepa = 21,
  TwoCTwoP = 22,
  PaymentOnDelivery = 23,
  BankTransfer = 24,
  Finvoice = 25,
  ProcessingKZ = 26,
  Yookassa = 27,
  RazorPay = 28,
  DirectDebitPostFinance = 29,
  DenizBank = 30,
  PaymentInSubsidiaryCashOnPickup = 31,
  PaymentInSubsidiaryCardViaTerminalOnPickup = 32,
  //PayByLink = 33 is a synthentic payment method, do not use this enum value
  PayByInvoice = 34,
  BraintreePayPalPayLater = 35,
  WorldpayKlarna = 36,
  WorldpayJCB = 37,
}
